import type { SVGProps } from "react";
import React from "react";

export const ChevronDown: React.FC<SVGProps<SVGSVGElement>> = ({
  fill = "#000",
  width = 25,
  height = 20,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.11654 7.10929C6.27192 6.96357 6.52384 6.96357 6.67922 7.10929L12 12.0992L17.3208 7.10929C17.4762 6.96357 17.7281 6.96357 17.8835 7.10929C18.0388 7.25501 18.0388 7.49126 17.8835 7.63698L12.2813 12.8907C12.2067 12.9607 12.1055 13 12 13C11.8945 13 11.7933 12.9607 11.7187 12.8907L6.11654 7.63698C5.96115 7.49126 5.96115 7.25501 6.11654 7.10929Z"
      fill={fill}
    />
  </svg>
);
